<template>
  <v-layout>
    <v-card width="100%">
      <div>
        <span v-html="title"></span>
      </div>
      <v-row no-gutters justify="center" class="pa-0 ma-0">
        <v-col cols="4" class="pa-0 ma-0 ttext"
          ><strong>ឈ្មោះជាអក្សរឡាតាំង</strong></v-col
        >
        <v-col cols="3" class="pa-0 ma-0 ttext"
          ><strong>ថ្ងៃ ខែ ឆ្នាំកំណើត</strong></v-col
        >
        <v-col cols="2" class="pa-0 ma-0 ttext"><strong>ភេទ</strong></v-col>
        <v-col cols="3" class="pa-0 ma-0 ttext"
          ><strong>កម្រិតវប្បធម៌</strong></v-col
        >
      </v-row>
      <v-row
        no-gutters
        justify="center"
        class="pa-0 mx-1"
        v-for="(value, row) in data.length"
        :key="row"
        row
        wrap
        justify-center
      >
        <v-col cols="4" class="py-0 my-0">
          <v-text-field
            class="ttext pt-0 mt-0 mx-1 px-0"
            outline
            hide-details
            v-model="data[row].dt[0]"
          />
        </v-col>
        <v-col cols="3" class="py-0 my-0">
          <v-text-field
            class="ttext pt-0 mt-0 mx-1 px-0"
            placeholder="dd-mm-yyyy"
            :rules="[rules.dob]"
            outline
            v-model="data[row].dt[1]"
          />
        </v-col>
        <v-col cols="2" class="py-0 my-0">
          <v-select
            class="pa-0 ma-0"
            v-model="data[row].dt[2]"
            :items="gender"
            item-text="text"
            item-value="value"
            outline
            hide-details
            @keypress.native="onSelect1($event)"
          />
        </v-col>
        <v-col cols="3" class="py-0 my-0">
          <v-select
            class="pa-0 ma-0"
            v-model="data[row].dt[3]"
            :items="degree"
            item-text="text"
            item-value="value"
            outline
            hide-details
          >
          </v-select>
        </v-col>
      </v-row>
    </v-card>
  </v-layout>
</template>

<script>
import { maleFemale, degree } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "title"],
  data() {
    return {
      gender: maleFemale,
      degree: degree,
      rules: {
        // :rules="[rules.required, rules.email]"
        required: (value) => !!value || "Required.",
        dob: (value) => {
          const pattern = /^(0[1-9]|[12][0-9]|3[01])[-/.](0[1-9]|1[012])[-/.](19|20)\d\d$/;
          if (pattern.test(value)) {
            return true;
          } else {
            return "សូមវាយទំរង់ dd-mm-yyyy";
          }
        },
      },
    };
  },
  methods: {
    onSelect1: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.gen = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 10px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-family: "Siemreap";
  font-size: 11px;
}
</style>